import HOC from "../../components/HOC";

import * as emoji from "node-emoji";
import { useContext, useEffect, useRef, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useFormik } from "formik";
import { Snackbar, IconButton, TextField, InputAdornment } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import Logo from "../../assets/olinfull.png";
import OlinMascot from "../../assets/olinCharaLogin.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { getGoogleInfo, login } from "../../services/authApi";
import { setUser } from "../../redux/features/auth/authSlice";
import { GlobalStateContext } from "../../components/context/GlobalStateContext";
import {
  getCustomerAddress,
  // getDistanceOutlet,
} from "../../services/purchaseApi";
import { generateTinodeSecret } from "../../services/tinodeApi";
import { IoArrowBack, IoInformationCircleOutline } from "react-icons/io5";
import { VscEye } from "react-icons/vsc";
import { RxEyeClosed } from "react-icons/rx";
import FullsizeButton from "../../components/common/FullsizeButton";
import AuthButton from "../../components/common/AuthButton";
import {
  getOrCreateDoctorWebPresenceSessionId,
  getOrCreateDoctorWebPresenceTabId,
} from "../../hooks/useDoctorWebPresenceHeartbeat";
import { writeSafeStorage } from "../../utils/localStorageHelper";

const formHelperFieldStyles = {
  width: "100%",
  display: "flex",
  justifyContent: "start",
  margin: "2px 0 0 0",
  fontSize: "12px",
  color: "#ef4444",
  fontFamily: '"Montserrat", sans-serif',
};

const getCleanPhoneNumber = (formatted) => {
  return formatted.replace(/[^\d+]/g, "");
};

const validationSchema = yup.object({
  email: yup
    .string()
    .required("Email atau nomor ponsel wajib diisi")
    .test(
      "email-or-phone",
      "Format email atau nomor ponsel tidak valid",
      function (value) {
        if (!value) return false;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(value)) {
          return true;
        }

        const cleanPhone = getCleanPhoneNumber(value);
        const phoneRegex = /^\+628\d{8,11}$/;
        if (phoneRegex.test(cleanPhone)) {
          return true;
        }

        return false;
      },
    ),
  password: yup
    .string()
    .required("Password wajib diisi")
    .min(8, "Password minimal 8 karakter"),
});
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const machineId = localStorage.getItem("MachineId");
  const lastPath = localStorage.getItem("LastPath");
  const { isLogin, loginRole, setLoginRole } = useContext(GlobalStateContext);
  const queryClient = useQueryClient();
  const isDoctorActive = localStorage.getItem("is_doctor_active") === "true";

  const tokenClientRef = useRef(null);

  const [statusCode, setStatusCode] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [secret, setSecret] = useState("Ym9iOmJvYjEyMw==");
  const [isMobileView, setIsMobileView] = useState(false);
  const [isPhoneInput, setIsPhoneInput] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setStatusCode(false);
    setErrorMessage("");
  };

  const handleLoginGoogle = () => {
    if (tokenClientRef.current) {
      formik.setValues({ email: "", password: "", uuid: "" });
      tokenClientRef.current.requestAccessToken();
    }
  };

  // const handleDataAddress = () => {
  //   if (!dataAddress) return;
  //   // If user has no address, get user location
  //   if (dataAddress && dataAddress.province === "") {
  //     if ("geolocation" in navigator) {
  //       try {
  //         navigator.geolocation.getCurrentPosition(
  //           (position) => {
  //             const { latitude, longitude } = position.coords;
  //             mutateDistance({
  //               latlong: latitude.toString() + "," + longitude.toString(),
  //               company_id: Number(localStorage.getItem("companyId")),
  //             });
  //           },
  //           (error) => {
  //             // Properly handle error without retry
  //             if (error.code === 1) {
  //               // User denied geolocation
  //               console.warn("Geolocation denied by user");
  //               queryClient.removeQueries({ queryKey: ["customer-address"] });
  //               if (isLogin || null || "") {
  //                 if (data.role === 2) {
  //                   navigate("/doctor-dashboard");
  //                 } else {
  //                   navigate(
  //                     lastPath &&
  //                       lastPath !== "/login" &&
  //                       lastPath !== "/register"
  //                       ? lastPath
  //                       : "/",
  //                   );
  //                 }
  //               } else {
  //                 navigate(
  //                   lastPath &&
  //                     lastPath !== "/login" &&
  //                     lastPath !== "/register"
  //                     ? lastPath
  //                     : "/purchase",
  //                 );
  //               }
  //             } else {
  //               // Other geolocation errors - just log, don't retry
  //               console.warn("Geolocation error:", error.message);
  //             }
  //           },
  //           {
  //             enableHighAccuracy: true,
  //             timeout: 5000, // Timeout after 5s
  //             maximumAge: 0, // Don't use cached location
  //           },
  //         );
  //       } catch (error) {
  //         // Catch any unexpected errors
  //         console.error("Unexpected geolocation error:", error);
  //       }
  //     }
  //   }
  //   // If user has address, change to nearest address
  //   if (
  //     dataAddress &&
  //     dataAddress.postal_code &&
  //     dataAddress.postal_code !== "" &&
  //     geocoder
  //   ) {
  //     geocoder.geocode(
  //       { address: dataAddress.postal_code, region: "ID" },
  //       (results, status) => {
  //         if (status === "OK" && results[0]) {
  //           const location = results[0].geometry.location;
  //           mutateDistance({
  //             latlong:
  //               location.lat().toString() + "," + location.lng().toString(),
  //             company_id: Number(localStorage.getItem("companyId")),
  //           });
  //         }
  //       },
  //     );
  //   }
  // };

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/[^\d+]/g, "");

    if (cleaned.startsWith("+62")) {
      const numbers = cleaned.substring(3);

      const limitedNumbers = numbers.substring(0, 11);

      let formatted = "(+62)";
      if (limitedNumbers.length > 0) {
        formatted += " " + limitedNumbers.substring(0, 3);
      }
      if (limitedNumbers.length > 3) {
        formatted += " " + limitedNumbers.substring(3, 7);
      }
      if (limitedNumbers.length > 7) {
        formatted += " " + limitedNumbers.substring(7, 11);
      }

      return formatted;
    }

    return value;
  };

  const handleEmailPhoneChange = (value) => {
    const isNumber =
      /^\d/.test(value) || value.startsWith("8") || value.startsWith("(+62)");

    if (isNumber && !value.includes("@")) {
      setIsPhoneInput(true);

      let cleaned = value.replace(/[^\d]/g, "");

      if (cleaned.startsWith("0")) {
        cleaned = "62" + cleaned.substring(1);
      } else if (cleaned.startsWith("8")) {
        cleaned = "62" + cleaned;
      } else if (!cleaned.startsWith("62")) {
        cleaned = "62" + cleaned;
      }

      cleaned = cleaned.substring(0, 13);

      const formatted = formatPhoneNumber("+" + cleaned);
      formik.setFieldValue("email", formatted);
    } else if (value === "" || value === "(+62)") {
      setIsPhoneInput(false);
      formik.setFieldValue("email", "");
    } else {
      setIsPhoneInput(false);
      formik.setFieldValue("email", value);
    }

    setErrorMessage("");
    setPasswordError("");
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      uuid: machineId,
    },
    validationSchema: validationSchema,

    onSubmit: (value) => {
      const submitValue = {
        ...value,
        email: isPhoneInput
          ? getCleanPhoneNumber(value.email)
          : value.email.toLowerCase(),
      };
      mutateLogin(submitValue);
    },
    validateOnMount: true,
  });

  const {
    mutate: mutateLogin,
    data,
    isPending,
  } = useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      if (data === undefined) return;
      dispatch(
        setUser({
          accessToken: data.token.access,
          accessExpired: data.token.access_expired,
          renewToken: data.token.renew,
          renewExpired: data.token.renew_expired,
          fullname: dataGoogle ? dataGoogle.given_name : data.fullname,
          email: data.email,
          role: data.role,
          user_id: data.user_id,
          profile_image: data.profile_image,
          no_sip: data?.no_sip,
          address: data?.address,
          phone_number: data?.phone_number,
        }),
      );

      if (data.company_id !== 0) {
        writeSafeStorage("companyId", data.company_id);
      }
      writeSafeStorage("role", data.role);
      setLoginRole(data.role);

      if (formik.values.password) {
        sessionStorage.setItem("tinode_password", formik.values.password);
      }

      const tinodeSecret = generateTinodeSecret(
        data.email,
        formik.values.password,
      );
      setSecret(tinodeSecret);
      console.log(
        "🔑 Generated Tinode secret for REST auth login:",
        tinodeSecret.substring(0, 20) + "...",
      );

      if (data.role === 2 && isDoctorActive) {
        localStorage.setItem(
          "is_doctor_active",
          data.status === 1 ? "true" : "false",
        );
        getOrCreateDoctorWebPresenceSessionId();
        getOrCreateDoctorWebPresenceTabId();
        sessionStorage.removeItem("doctor_web_presence_last_heartbeat_ts");

        window.location.href = "/doctor-dashboard";
      } else {
        window.location.href = "/";
      }

      writeSafeStorage("email", data.email);
      writeSafeStorage("address", data?.address);
      writeSafeStorage("phone_number", data?.phone_number);
      refetchAddress();
    },
    onError: (err) => {
      setErrorMessage(err.message.id);
    },
  });

  const { data: dataAddress, refetch: refetchAddress } = useQuery({
    queryKey: ["customer-address"],
    queryFn: () => getCustomerAddress(),
    enabled: false,
  });

  // const { mutate: mutateDistance } = useMutation({
  //   mutationFn: getDistanceOutlet,
  //   onSuccess: (dataDistance) => {
  //     // localStorage.setItem("companyId", dataDistance.company_id);

  //     // ⚠️ CEK ROLE DARI DATA LOGIN, BUKAN DARI isLogin
  //     const userRole = localStorage.getItem("role"); // Ambil dari localStorage

  //     if (userRole === "2") {
  //       console.log("🚑 DOCTOR - Skip distance redirect");
  //       return; // ⛔ JANGAN REDIRECT
  //     }

  //     // HANYA UNTUK CUSTOMER
  //     if (lastPath && lastPath !== "/login" && lastPath !== "/register") {
  //       navigate(lastPath, { replace: true });
  //     } else {
  //       navigate("/purchase", { replace: true });
  //     }
  //   },
  // });

  const { data: dataGoogle } = useQuery({
    queryKey: ["google-user", accessToken],
    queryFn: () => getGoogleInfo(accessToken),
    enabled: accessToken !== null,
    refetchOnWindowFocus: false,
    keepPreviousData: false,
  });

  // useEffect(() => {
  //   handleDataAddress();
  // }, [dataAddress]);

  useEffect(() => {
    if (dataGoogle) {
      mutateLogin({
        email: dataGoogle.email,
        password: "",
        uuid: machineId,
        fullname: dataGoogle.given_name,
      });
    }
  }, [dataGoogle]);

  // useEffect(() => {
  //   const id = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  //   const interval = setInterval(() => {
  //     if (window.google && id) {
  //       tokenClientRef.current = window.google.accounts.oauth2.initTokenClient({
  //         client_id: id,
  //         scope: "profile email openid",
  //         callback: (response) => {
  //           setAccessToken(response.access_token);
  //         },
  //       });
  //       clearInterval(interval);
  //     }
  //   }, 1000);
  // }, []);

  return (
    <div className="bg-white relative">
      <FullsizeButton />
      <div className="flex flex-row justify-center h-screen">
        <div className="hidden md:order-last bg-cover lg:block lg:w-1/2">
          <div className="flex items-center h-full p-8 bg-white justify-center">
            <div className="w-[30vw] h-[30vw] flex justify-center object-cover items-center rounded-full p-8 bg-blue-100">
              <div className="p-16 bg-blue-300 rounded-full w-full h-full">
                <img
                  src={OlinMascot}
                  className="w-full h-full"
                  alt="Olin Maskot"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-1/2 flex justify-center lg:items-center px-0 lg:px-12 text-base">
          <div className="rounded-md p-4 lg:p-8 w-full h-fit">
            <div className="w-full flex items-center gap-4 lg:hidden text-xl">
              <div
                onClick={() => navigate(-1)}
                className="p-1 hover:bg-gray-200 rounded-full"
              >
                <IoArrowBack className="text-gray-500" />
              </div>
              <p className="font-semibold text-primary-700">Masuk</p>
            </div>
            <img
              src={Logo}
              alt="Logo OLIN"
              className={`my-8 ${
                isMobileView ? "w-[80px] mt-12" : "w-[100px] mt-16"
              }`}
            />
            <div className="text-3xl font-bold text-black my-10 lg:my-4 items-center hidden lg:flex gap-2">
              <p>Selamat Datang Kembali</p>
              {emoji.emojify(":wave:")}
            </div>
            <p className="mb-8 text-lg text-disableText hidden lg:block">
              Silahkan masukkan akun OLIN Pharmacy Management System anda
            </p>

            <form onSubmit={formik.handleSubmit}>
              <div className="space-y-4">
                <div>
                  {/* <p>Email / Nomor Ponsel</p> */}
                  <p>Email</p>
                  <TextField
                    fullWidth
                    type="email"
                    name="email"
                    id="email"
                    // placeholder={
                    //   isPhoneInput
                    //     ? "(+62) 8xx xxxx xxxx"
                    //     : "Masukkan email atau nomor ponsel"
                    // }
                    placeholder="Masukkan email"
                    variant="outlined"
                    value={formik.values.email}
                    onChange={(e) => handleEmailPhoneChange(e.target.value)}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={
                      formik.touched.email && formik.errors.email
                        ? formik.errors.email
                        : ""
                    }
                    disabled={isPending}
                    InputProps={{
                      sx: {
                        backgroundColor: "white",
                        borderRadius: "10px",
                        color: "#111827",
                        transition: "all 0.4s",
                        paddingRight: "40px",
                        fontFamily: '"Montserrat", sans-serif',
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderWidth: "1px",
                          borderColor:
                            formik.touched.email && formik.errors.email
                              ? "#ef4444"
                              : "#d1d5db",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor:
                            formik.touched.email && formik.errors.email
                              ? "#ef4444"
                              : "#9ca3af",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#111827",
                          borderWidth: "1px",
                        },
                        "& .MuiInputBase-input": {
                          padding: "14px 12px",
                          color: "#111827",
                          fontSize: { xs: "14px", lg: "16px" },
                          fontFamily: '"Montserrat", sans-serif',
                          "&::placeholder": {
                            color: "#CBCBCB",
                            opacity: 1,
                            fontFamily: '"Montserrat", sans-serif',
                          },
                          paddingRight: "8px",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#f9fafb",
                          opacity: 0.7,
                        },
                      },
                    }}
                    FormHelperTextProps={{
                      sx: formHelperFieldStyles,
                    }}
                  />
                </div>

                <div>
                  <p>Password</p>
                  <TextField
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    placeholder="Password"
                    variant="outlined"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                        ? formik.errors.password
                        : ""
                    }
                    disabled={isPending}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {showPassword ? (
                            <RxEyeClosed
                              onClick={() => setShowPassword(!showPassword)}
                              className="cursor-pointer"
                            />
                          ) : (
                            <VscEye
                              onClick={() => setShowPassword(!showPassword)}
                              className="cursor-pointer"
                            />
                          )}
                        </InputAdornment>
                      ),
                      sx: {
                        backgroundColor: "white",
                        borderRadius: "10px",
                        color: "#111827",
                        transition: "all 0.4s",
                        fontFamily: '"Montserrat", sans-serif',
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderWidth: "1px",
                          borderColor:
                            formik.touched.password && formik.errors.password
                              ? "#ef4444"
                              : "#d1d5db",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor:
                            formik.touched.password && formik.errors.password
                              ? "#ef4444"
                              : "#9ca3af",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#111827",
                          borderWidth: "1px",
                        },
                        "& .MuiInputBase-input": {
                          padding: "14px 12px",
                          color: "#111827",
                          fontSize: { xs: "14px", lg: "16px" },
                          fontFamily: '"Montserrat", sans-serif',
                          "&::placeholder": {
                            color: "#CBCBCB",
                            opacity: 1,
                            fontFamily: '"Montserrat", sans-serif',
                          },
                          paddingRight: "8px",
                        },
                        "&.Mui-disabled": {
                          backgroundColor: "#f9fafb",
                          opacity: 0.7,
                        },
                      },
                    }}
                    FormHelperTextProps={{
                      sx: formHelperFieldStyles,
                    }}
                  />
                </div>
              </div>

              <div className="mt-4 w-full flex justify-end">
                <div className="w-fit text-right font-medium font-display text-primary hover:text-blue-800 cursor-pointer hover:underline">
                  <Link to="/forgot-password">
                    <p>Lupa Password?</p>
                  </Link>
                </div>
              </div>

              {errorMessage && (
                <div className="w-full flex justify-end mt-2">
                  <div className="flex items-center gap-2 bg-red-100 py-1.5 px-2.5 rounded-md">
                    <IoInformationCircleOutline
                      className="text-error shrink-0"
                      size={12}
                    />
                    <p className="text-sm text-red-700">{errorMessage}</p>
                  </div>
                </div>
              )}

              <div className="mt-6 flex flex-col lg:flex-row gap-2 lg:gap-2 items-center">
                <>
                  <AuthButton
                    title={"Masuk"}
                    isPending={isPending}
                    formik={formik}
                  />

                  {/* <p className="my-2 text-[12px] w-fit text-center hidden lg:block">
                    or
                  </p>


                    type="button"
                    onClick={handleLoginGoogle}
                    disabled={isPending}
                    className="h-[45px] flex items-center justify-center w-full bg-white border border-gray-300 rounded-lg p-3 font-medium text-gray-700 hover:bg-gray-100 gap-2 shadow-lg transform duration-200 hover:scale-100 disabled:bg-white disabled:cursor-disabled"
                  >
                    <>
                      <img
                        src="https://developers.google.com/identity/images/g-logo.png"
                        alt="Google"
                        className="w-5 h-5"
                      />
                      <p className="hidden md:block">Sign in with Google</p>
                      <p className="md:hidden">Masuk dengan Google</p>
                    </>
                  </button> */}
                </>
              </div>
            </form>
            <hr className="my-6 lg:my-10" />
            <p className="text-center mb-8">
              Belum punya akun?{" "}
              <span
                className="cursor-pointer text-primary hover:text-blue-700 font-medium hover:underline"
                onClick={() => navigate("/register")}
              >
                Daftar
              </span>
            </p>
          </div>
        </div>
      </div>
      <Snackbar
        open={statusCode || (errorMessage !== "" && !passwordError)}
        autoHideDuration={5000}
        onClose={() => {
          setStatusCode(false);
          setErrorMessage("");
        }}
        message={errorMessage}
        action={
          <>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        }
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      />
    </div>
  );
};

export default HOC(Login, "guest-only");
